import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { CustomerWishlist } from "@core/types";
import { productsClient } from "@core/clients";

type WishlistQuery = {
  options?: UseQueryOptions<CustomerWishlist | null, any, CustomerWishlist | null, any>;
};

const useGetWishlistQuery = ({ options }: WishlistQuery = {}) => {
  return useQuery(
    ["get-wishlist"],
    async () => {
      return await productsClient.getWishlist();
    },
    {
      cacheTime: 50000, // 50 seconds
      staleTime: 50000, // 50 seconds
      ...options,
    },
  );
};

export default useGetWishlistQuery;
